/**
 * Handlery pre asynchrónnu navigáciu v Detail stránkach pri progressive loading.
 * Používa API endpointy namiesto lokálneho poľa (createArrayNavigateHandlers).
 * @param {function} fetchRecord - async (direction, currentId?) => Promise<record|null>
 *   direction: 'first'|'prev'|'next'|'last'
 *   currentId: pre prev/next
 * @param {function} setItem - callback na nastavenie položky (setForm...)
 * @param {function} getCurrentId - () => currentId, volané pri scrollUp/scrollDown
 */
export function createAsyncNavigateHandlers(fetchRecord, setItem, getCurrentId = () => null) {
  const apply = (data) => {
    if (data) setItem(data);
  };
  return {
    scrollToFirst: () => fetchRecord('first').then(apply),
    scrollUp: () => fetchRecord('prev', getCurrentId()).then(apply),
    scrollDown: () => fetchRecord('next', getCurrentId()).then(apply),
    scrollToLast: () => fetchRecord('last').then(apply),
  };
}
